/** @type {Map<string, CSSStyleSheet>} */
export const CSSCache = new Map();
/** @type {Map<string, DocumentFragment>} */
export const HTMLCache = new Map();
